// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "213064455146b0f55601fce08958681b3d158aa4/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};